import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { MenuItem } from "primeng/api";
import { Observable } from "rxjs";

import { Auditor } from "@app/Domain/Models/auditor.model";
import { environment } from "environments/environments";
import { BaseService } from "../base.service";
import { SessionStorageService } from "../session-storage.service";

@Injectable({
    providedIn: "root"
})
export class HttpMenuService extends BaseService {
    private urlmenu = environment.BaseUrl + "MenuPerfil/";

    private sessionStorage = inject(SessionStorageService);
    private auditor: Auditor = this.sessionStorage.get("auditor");
    private http = inject(HttpClient);

    getMenus(): Observable<MenuItem[]> {
        return this.http.get<MenuItem[]>("./mock/menus.json");
    }

    GetMenuPerfil(idPerfil: number, idPais: number): Observable<MenuItem[]> {
        let menu = this.http.get<MenuItem[]>(
            this.urlmenu + "byPerfilPais/" + idPerfil + "/" + idPais,
            this.getHeader(this.auditor.idiomaAuditorInterface)
        );
        return menu;
    }
}
